import { useEffect, useState } from "react";
import VerificationTab from "./VerificationTab";
import CategoryReviewTab from "./CategoryReviewTab";
import { SubTabs } from "./AdminUI";

const TABS = [
  { key: "verification", label: "Verification & Roster" },
  { key: "categories", label: "Category Review" },
];

export default function ProfessionalsTab({ initialTab }) {
  const [tab, setTab] = useState(initialTab === "categories" ? "categories" : "verification");
  useEffect(() => { if (initialTab) setTab(initialTab); }, [initialTab]);
  return (
    <div data-testid="admin-professionals-tab">
      <SubTabs tabs={TABS} active={tab} onChange={setTab} testidPrefix="pro-tab" />
      {tab === "verification" ? <VerificationTab /> : <CategoryReviewTab />}
    </div>
  );
}
